export default __webpack_public_path__ + "assets/img/react_logo.5b197262b6f2d51239cafdfbc6bb0487.svg";